module.exports = __webpack_public_path__ + "static/images/arrow-dotted-down.39f54986f043656a89c0995d7c02e0cd.svg";